import { Component, input } from "@angular/core";
import { RouterLink } from "@angular/router";

export interface Crumb {
  label: string;
  /** Router path. Leave empty for the current page, which renders as plain text. */
  url?: string;
}

@Component({
  selector: "app-breadcrumb",
  imports: [RouterLink],
  templateUrl: "./breadcrumb.html",
  styleUrl: "./breadcrumb.scss"
})
export class Breadcrumb {
  /** Trail after Home. The last entry is treated as the current page. */
  readonly trail = input.required<Crumb[]>();
}
